var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-page px-md-5" },
    [
      _c("drip-campaign-header", {
        on: { "show-create": _vm.handleShowCreateModal },
      }),
      _vm._v(" "),
      _c("drip-campaign-search"),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c("drip-campaign-navbar", {
              on: { "tab-change": _vm.handleFilterChange },
            }),
            _vm._v(" "),
            _vm.loading.table
              ? _c("drip-campaign-table-loader")
              : _c("drip-campaign-table", {
                  attrs: { campaigns: _vm.filteredCampaigns[_vm.filter] },
                  on: { "show-clients": _vm.handleShowClients },
                }),
            _vm._v(" "),
            _c("drip-campaign-name-modal", {
              ref: "nameModal",
              attrs: { loading: _vm.loading.creatingCampaign },
              on: { create: _vm.handleCreateDripCampaign },
            }),
            _vm._v(" "),
            _vm.showClientsForCampaignId
              ? _c("drip-campaign-clients-modal", {
                  ref: "clientsModal",
                  attrs: { "campaign-id": _vm.showClientsForCampaignId },
                  on: {
                    deleted: _vm.getAllCampaigns,
                    hide: function ($event) {
                      _vm.showClientsForCampaignId = ""
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }